import React, { useEffect, useState } from "react";
import PlaceOrderView from "./PlaceOrderView";
import { clearOrderCache, getAddressHome, getContactInfo, getDeviceInfo, getPackageInfo, getPaymentMethod, getUTMInfo, isVumaReachPackage, logOut, setAmountPayment, setContactInfo, setPaymentLinkInfo, setUTMInfo } from "../../utils/commons";
import { cached } from "../../utils/cache";
import { httpUtil } from "../../services/wsclients/httpUtil";
import { useTranslation } from "react-i18next";
import { lab4services } from "../../services/wsclients/lab4services";
import { useHistory } from "react-router-dom";
import CustomLoading from "../../components/CustomLoading";
import ProcessFormView from "./ProcessFormView";
import { paths } from "../../config/router.config";
import { connection } from "../../config";
import { PRODUCT_TYPES, STEPS_REGISTER } from "../../utils/util";
import wsclients from "../../services/wsclients";
import { ErrorCodes } from "../../services/wsclients/resultUtil";
import VerificationView from "../../components/VerificationView";
import CustomAlert from "../../components/CustomAlert";
import { useTheme } from '@mui/material/styles';

export default function PlaceOrderController(props) {
    const [isAcceptTC, setIsAcceptTC] = useState(false);
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [otp, setOtp] = useState('');
    const [openVerificationView, setOpenVerificationView] = useState(false);
    const [openContactExistsDialog, setOpenContactExistsDialog] = useState(false);
    const [tempEmail, setTempEmail] = useState('');
    const [idOtp, setIdOtp] = useState('');
    const [loadingOtp, setLoadingOtp] = useState(false);

    const { palette } = useTheme();
    const { t } = useTranslation();
    const history = useHistory();

    const package_info = getPackageInfo();
    const billingInfo = cached.getBillingInfo();
    const contactInfo = cached.getContactInfo();
    const addressHome = cached.getAddressInfo(); //enter in form data rica
    const address = getAddressHome(); //search 1Map

    useEffect(() => {
        if (contactInfo && contactInfo.email) setTempEmail(contactInfo.email);
    },[]);

    const onPlaceOrder = async () => {
        if (
            package_info && (
                package_info.product_type == 'vuma_core'
                || package_info.product_type == 'openserve'
                || package_info.product_type == 'octotel'
                || package_info.product_type == 'metrofibre')
        ) {
            onShowMessage({
                show: true,
                content: t('agree_term_message'),
                isConfirm: true,
                confirmAction: {
                    okAction: async () => {
                        onShowMessage({});
                        await onMakeOrderV2()
                    },
                    okTitle: t('Agree'),
                    cancelAction: () => onShowMessage({}),
                },
                title: t('Information Consent')
            })
        } else {
            await onMakeOrderV2();
        }
        // props.stepsControl.goToStepByName(STEPS_REGISTER.done);
    }

    const onMakeOrderV2 = async (contactReq) => {
        onShowLoading(true)
        try {
            console.log("contactInfo", contactInfo)
            console.log("AAAA addressHome", addressHome)
            // debugger
            let body = {
                product_id: package_info?.id || null,
                location_reference: address?.metrofibre_ref_isp || address?.premise_ref_isp || address?.premisesid,
                product_reference: package_info?.sku || null,
                payment_redirect_url: window.location.origin + paths.orders_result,
                is_recuring: billingInfo?.is_recuring || false,
                recurring_payment_date: package_info?.recurring_payment_date || null,
                product_type: package_info?.product_type || null,
                order_amount: package_info?.price || 0,
            }
            if (package_info?.product_type === PRODUCT_TYPES.metrofibre) {
                // body.product_reference = package_info.code;
                body.product_reference = package_info?.product?.custom_fields?.find(x => x.key == 'metrofibre_tariff_id')?.value || package_info.code;
            }
            if (contactReq && Object.keys(contactReq).length > 0) {
                body.contact_id = contactReq?.contact_id
                body.contact_code = contactReq?.contact_code
            }
            const isPackageMetrofibre = package_info?.product_type == PRODUCT_TYPES.metrofibre;
            const isPackageVumaCore = package_info?.product_type === PRODUCT_TYPES.vuma_core;
            const isPackageOpenserve = package_info?.product_type === PRODUCT_TYPES.openserve;
            let contact = {
                first_name: contactInfo?.first_name || null,
                last_name: contactInfo?.last_name || null,
                id_number: contactInfo.id_number,
                passport_number: contactInfo.passport_number,
                identification: {
                    username: contactInfo?.email || null,
                    password: contactInfo?.password || null,
                    validation_required: false,
                },
                phone_number: contactInfo.phone_number,
                referral_code: contactInfo.referral_code,
                country_code: 'ZAF',//hardcode,
                service_acceptance: true,
                email_opt_out: false,
                sms_opt_out: false,
                address: {
                    // address_type: 'HOME',
                    address_line_1: addressHome.street_number + ", " + addressHome.street_name,
                    address_line_2: address?.suburb || null,
                    state_province_county: addressHome?.state_province_county || null,
                    town_city: addressHome.town_city,
                    postal_code: addressHome.postal_code,
                    lat: address?.latitude || null,
                    lon: address?.longitude || null,
                    apartment_name: addressHome?.apartment_name || null,
                    apartment_number: addressHome?.apartment_number || null,
                    vumatel_premise_id: address?.premisesid || null,
                    network_type: address ? (address.network_type || address.networktype || null) : null,
                    building: addressHome?.building || null,
                    mdu_name: addressHome?.mdu_name || null,
                    mdu_unitno: addressHome?.mdu_unitno || null,
                    uuid: address.premisesid ? address.premisesid : null,
                    metrofibre_ref_isp: address?.metrofibre_ref_isp && isPackageMetrofibre ? address.metrofibre_ref_isp : null,
                    metrofibre_polygon_id: address?.metrofibre_polygon_id && isPackageMetrofibre ? address.metrofibre_polygon_id : null
                }
            }
            if (package_info?.reconnect) contact.reconnect = package_info.reconnect;
            if (package_info?.ont) contact.ont = package_info.ont;
            if (package_info?.line_uuid?.uuid) contact.line_uuid = package_info.line_uuid.uuid;
            let deviceInfo = getDeviceInfo();
            if (isPackageVumaCore && deviceInfo) {
                contact.device_name = deviceInfo.name ? deviceInfo.name : null;
            }
            else if (isPackageOpenserve) {
                if (deviceInfo) {
                    contact.device_name = deviceInfo.name ? deviceInfo.name : null;
                }
                body.openserve_location_reference = address?.openserve_ref_isp || null
                body.location_reference = address?.openserve_ref_isp || null
            }
            body.contact = contact;
            let utm_info = getUTMInfo();
            if (utm_info && utm_info.utm_source && utm_info.utm_campain) {
                body.utm_source = utm_info.utm_source;
                body.utm_campain = utm_info.utm_campain;
            }
            // debugger;
            console.log("AAAA body result: ", body);
            let isPreOrder = address?.pre_order_allowed;
            if (isPreOrder) {
                await onMakePreOrder(body)
                return;
            }
            let result = await lab4services.registerContact(body);
            console.log("AAAA onMakeOrderV2 result: ", result);
            if (result.code == 'OK') {
                setUTMInfo(null)
                if (!contactReq && result?.data?.access_token) {
                    httpUtil.startSession({
                        access_token: result.data.access_token,
                    })
                }
                if (!isVumaReachPackage(package_info?.product_type)) {
                    let paymentMethodCache = billingInfo?.option_payment;
                    setContactInfo({
                        id: result.data.contact_id,
                        email: contactInfo.email,
                        code: result.data.contact_code,
                    });
                    if (paymentMethodCache == 'PAYGATE') {
                        setPaymentLinkInfo({
                            type: 'register',
                            ...result.data,
                        });
                        await initPayment();
                    }
                    else {
                        if (result.data && result.data.payment_easypay_url) {
                            await handleEasyPay(result);
                        } else {
                            console.log("do nothing ....")
                        }
                    }
                } else {
                    clearOrderCache();
                    await wait(2000);
                    window.location.href = result.data.vumatel_payment_url;
                    return;
                }
            } else {
                handleResponseMakeOrder(result);
            }
        } catch (ex) {
            console.log("AAAA onMakeOrderv2 exception: ", ex);
            onShowMessage({ show: true, content: t('CREATE_ORDER_FAILED')});
        } finally {
            onShowLoading(false)
        }
    }

    const handleEasyPay = async (result) => {
        window.open(result.data.payment_easypay_url, '_blank');
        let isComplete = false;
        for (let i = 0; i < 5; i++) {
            if (isComplete) break;
            await wait(5000);
            isComplete = await getPaymentEasyPayInfo({ id: result.data.contact_id });
        }
        console.log("AAAA isComplete: ", isComplete)
        if (isComplete) {
            logOut();
            clearOrderCache();
            await wait(2000);
            props.stepsControl.goToStepByName(STEPS_REGISTER.done);
        } else {
            onShowMessage({
                show: true,
                content: 'Please continue payment easypay.',
                action: () => {
                    logOut();
                    clearOrderCache();
                    props.stepsControl.goToStepByName(STEPS_REGISTER.done);
                }
            });
        }
    }

    const onMakePreOrder = async (body) => {
        console.log("AAAA onMakePreOrder body: ", body)
        try {
            let result = await lab4services.makePreorder(body);
            if (result.code == 'OK') {
                setUTMInfo(null);
                clearOrderCache();
                await wait(2000);
                // history.push(paths.home);
                props.stepsControl.goToStepByName(STEPS_REGISTER.done);
            } else {
                handleResponseMakeOrder();
            }
        } catch (error) {
            console.log("AAAA onMakePreOrder error: ", error)
        }
    }

    const handleResponseMakeOrder = (result) => {
        if (result?.code == 'LOCATION_REFERENCE_IS_NOT_AVAILABLE') {
            onShowMessage({ show: true, content: t('address_used')});
            return false;
        }
        if (result?.code === 'CREATE_CRM_ORDER_EXCEPTION') {
            onShowMessage({ show: true, content: t('CREATE_CRM_ORDER_EXCEPTION')});
            return false;
        }
        let errorCodeApi = result?.data?.error.error;
        if (errorCodeApi == 'ORDER_FOR_CONTACT_IS_ALREADY_EXIST') {
            setOpenContactExistsDialog(true);
            return false;
        }
        if (errorCodeApi == 'ID_NUMBER_OR_PASSPORT_ALREADY_EXIST') {
            onShowMessage({ show: true, content: t('ID_NUMBER_OR_PASSPORT_ALREADY_EXIST')
            });
            return false;
        }
        if (errorCodeApi == 'CONTACT_ALREADY_SUBSCRIPTION') {
            onShowMessage({ show: true, content: t('CONTACT_ALREADY_SUBSCRIPTION')});
            return false;
        }
        let entity = result?.data?.error?.entity ? JSON.parse(result.data.error.entity) : null;
        let message = entity?.detail && typeof (entity.detail) === 'string' ? entity.detail : t('NETWORK_ISSUE');
        onShowMessage({ show: true, content: message });
    }

    const getPaymentEasyPayInfo = async (contact) => {
        let isComplete = false;
        try {
            let result = await lab4services.getOrderStatusV2({
                contact_id: contact.id,
                order_type: package_info.product_type,
            });
            if (result.code == 'OK' && result.data && result.data.status) {
                isComplete = result.data.status == 'COMPLETE' ? true : false;
            }
        } catch (error) {
            console.log("AAAA getPaymentEasyPayInfo error: ", error)
        }
        return isComplete;
    }

    const initPayment = async (isLoading) => {
        try {
            onShowLoading(isLoading)
            let contact_info = getContactInfo();
            let amount = package_info?.price || null;
            setAmountPayment(amount);
            let body = {
                contact_id: contact_info?.id || null,
                email_address: contact_info?.email || null,
                contact_code: contact_info?.code || null,
                amount: amount,
                type: billingInfo?.save_card ? 'CAPTURE_CARD' : 'NO_CAPTURE_CARD',
            };
            let result;
            if (connection.newApiFlow) result = await lab4services.initTopup(body);
            else result = await lab4services.initPayment(body);
            console.log("result initPayment ===", result);
            if (result?.code != 'OK') {
                onShowMessage({
                    show: true,
                    message: t('INIT_PAYMENT_FAILED'),
                    isConfirm: true,
                    confirmAction: {
                        okAction: async () => await initPayment(true),
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        cancelAction: () => history.push(paths.home),
                    },
                });
                return false;
            }
            let urlFormPaygate = document._portalConfig.urlFormPaygate;
            if (result?.data?.client_token) {
                let clientToken = result.data.client_token;
                var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                console.log('splitToken:', splitToken);
                if (splitToken.length > 0) {
                    var payRequestIDRes = splitToken[0];
                    var checkSumRes = splitToken[1];
                    var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                        + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                        + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                        + '</form>'
                    console.log('htmlContent:', htmlContent);
                    setHtmlContent(htmlContent);
                    setOpenProcessForm(true);
                }
            }
            else if (result?.data?.state === 'REJECTED') {
                onShowMessage({
                    show: true,
                    message: t('INIT_PAYMENT_REJECTED'),
                    isConfirm: true,
                    confirmAction: {
                        okAction: async () => await initPayment(true),
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        cancelAction: () => history.push(paths.home),
                    },
                })
            }
        } catch (ex) {
            console.log("initPayment exception ===", ex);
        } finally {
            onShowLoading(false)
        }
    }

    const wait = m => new Promise(r => setTimeout(r, m))

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message);
    }

    const handleVerifyOtp = async () => {
        setLoadingOtp(true)
        try {
            onShowLoading(true);
            let result = await wsclients.contacts.authenticate({
                "provider": "EMAIL",
                "username": contactInfo.email,
                "application_id": document._portalConfig.applicationID
            }, true);
            console.log("Authenticate result:", result);
            if (result.code === ErrorCodes.OK) {
                setIdOtp(result.data.auth_otp);
                setOpenContactExistsDialog(false);
                setOpenVerificationView(true);
            } else {
                let errorMessage;
                switch (result.code) {
                    case ErrorCodes.INVALID_LOGIN:
                        errorMessage = t('INVALID_LOGIN');
                        break;
                    case ErrorCodes.EMAIL_NOT_VERIFIED:
                        errorMessage = t('EMAIL_NOT_VERIFIED');
                        break;
                    case ErrorCodes.TOO_MANY_REQUESTS:
                        errorMessage = t('TOO_MANY_REQUESTS');
                        break;
                    default:
                        errorMessage = t('UNCLASSIFIED_ERROR');
                }
                onShowMessage({
                    show: true,
                    content: errorMessage,
                    isConfirm: false,
                    showButtonClose: true,
                    onClose: () => onShowMessage({})
                });
            }
        } catch (error) {
            console.log("Authenticate exception:", error);
            onShowMessage({
                show: true,
                content: t('UNKNOWN'),
                isConfirm: false,
                showButtonClose: true,
                onClose: () => onShowMessage({})
            });
        } finally {
            onShowLoading(false);
            setLoadingOtp(false)
        }
    }

    const handleCancelDialog = () => {
        setOpenContactExistsDialog(false);
    }

    const handleOtpSubmit = async () => {
        try {
            onShowLoading(true);
            let result = await wsclients.contacts.verifyOtp({ auth_otp: idOtp, code: otp });
            if (result.code === 'OK') {
                if (result.data.access_token) {
                    httpUtil.startSession({
                        access_token: result.data.access_token,
                    })
                }
                let resultContact = await wsclients.contacts.getContact();
                if (resultContact.code == "OK") {
                    setOpenProcessForm(true)
                    setOpenVerificationView(false);
                    await onMakeOrderV2({ 
                        contact_id: resultContact?.data?.id, 
                        contact_code: resultContact?.data?.code 
                    });
                }
            } else {
                onShowMessage({ show: true, content: t('INVALID_OTP') });
            }
        } catch (error) {
            console.log("OTP verification error:", error);
            onShowMessage({ show: true, content: t('EXCEPTION') });
        } finally {
            onShowLoading(false);
        }
    }
    
    return (
        <>
            {showLoading && <CustomLoading open={showLoading} />}
            <PlaceOrderView
                {...props}
                isAcceptTC={isAcceptTC}
                billingInfo={billingInfo}
                packageInfo={package_info}
                openContactExistsDialog={openContactExistsDialog}
                tempEmail={tempEmail}
                loadingOtp={loadingOtp}
                setIsAcceptTC={setIsAcceptTC}
                onPlaceOrder={onPlaceOrder}
                setOpenContactExistsDialog={setOpenContactExistsDialog}
                setTempEmail={setTempEmail}
                handleCancelDialog={handleCancelDialog}
                handleVerifyOtp={handleVerifyOtp}
            />
            {message.show && <CustomAlert
                open={message.show}
                message={message.content ? message.content : (message.message ? message.message : 'Unknown error!')}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => onShowMessage({})}
                okTitle={message.okTitle}
                cancelTitle={message.cancelTitle}
                title={message.title}
                color={palette.primary.main}

            />}
            {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}            
            {!showLoading && <VerificationView
                otp={otp}
                isOpen={openVerificationView}
                title={t('VERIFY_OTP')}
                obfuscated_value={tempEmail ? tempEmail.replace(/(.{2}).*?(@.*)/, '$1****$2') : ''}
                showProcessing={showLoading}
                message={message.content}
                onClose={() => setOpenVerificationView(false)}
                setOtp={setOtp}
                onSubmit={handleOtpSubmit}
            />}
        </>
    )
}